(() => {
  let initializedOnce;

  function trackArticleScroll(progressBarElements, articleEl) {
    if (!progressBarElements || progressBarElements.length === 0) {
      return;
    }

    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    const viewPortHeight = window.innerHeight;
    const articleOffsetHeight = articleEl.offsetHeight;
    const articleOffsetTop = articleEl.offsetTop;
    const heightToArticleBottom = articleOffsetHeight + articleOffsetTop;
    const scrollHeight = heightToArticleBottom - viewPortHeight;

    const scrolled = (winScroll / scrollHeight) * 100;
    const progress = scrolled > 100 ? 100 : scrolled;

    progressBarElements.forEach((progressBar) => {
      progressBar.style.width = `${progress}%`;
    });
  }

  function init() {
    if (initializedOnce) {
      return;
    }
    initializedOnce = true;

    // if no park-article stop init of scroll event tracker
    const articleEl = document.querySelector('.park-article-premium');
    if (!articleEl) {
      return;
    }

    const progressBars = document.querySelectorAll('.park-article-scroll-progress__progress-bar');
    window.onscroll = () => trackArticleScroll(progressBars, articleEl);
  }

  document.addEventListener('DOMContentLoaded', init);

  if (document.readyState !== 'loading') {
    init();
  }
})();
